import { toast } from "react-toastify"

export const Notice = {
  success: (title: string, timeout: number = 3000) => toast(title, { type: "success", autoClose: timeout }),
  warning: (title: string, timeout: number = 3000) => toast(title, { type: "warning", autoClose: timeout }),
  error: (title: string, timeout: number = 3000) => toast(title, { type: "error", autoClose: timeout }),
  info: (title: string, timeout: number = 3000) => toast(title, { type: "info", autoClose: timeout }),
}
